import React, { useEffect, useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { useLocation } from '@reach/router';
import { Link } from 'gatsby';
import { scroller } from 'react-scroll';

import './styles.scss';
import NavLink from './Link';

function Navbar() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const location = useLocation();
  const { pathname, search } = location;

  // US = / (default); /uk mirrors blog & tutorials
  const isUK = pathname.startsWith('/uk');
  const isPlumbers = pathname.startsWith('/plumbers');
  const prefix = isUK ? '/uk' : '';
  const homePath = isUK ? '/uk' : '/';

  const isOnDefaultHome = pathname === '/';

  // Helper: for section links, return the right URL for NavLink
  const getSectionLink = (section) => {
    if (
      (isUK && pathname === '/uk') ||
      (isOnDefaultHome && !isPlumbers) ||
      (isPlumbers && pathname === '/plumbers')
    ) {
      return `#${section}`;
    }
    if (isPlumbers) {
      return `/plumbers?section=${section}`;
    }
    if (isUK) {
      return `/uk?section=${section}`;
    }
    return `/?section=${section}`;
  };

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(() => {
        setIsScrolled(window.pageYOffset > 450);
        ticking = false;
      });
    };

    document.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (search) {
      const section = search.split('?section=')[1];
      if (section) {
        scroller.scrollTo(section, {
          duration: 1000,
          delay: 0,
          offset: -78,
          smooth: 'easeInOutQuart',
        });
      }
      // navigate('/');
    }
  }, [search]);

  const onLinkClick = () => {
    setIsExpanded(false);
  };

  useEffect(() => {
    onLinkClick();
  }, [pathname]);

  return (
    <header className="header">
      <nav
        className={`navbar navbar-default navbar-fixed-top ${
          isScrolled ? 'opaque' : ''
        }`}
      >
        <div className="container">
          <nav className="navbar navbar-expand-lg">
            <Link className="navbar-brand" to={homePath}>
              <StaticImage
                className="logo"
                src="../../images/logo.png"
                alt="timesheet logo"
              />
            </Link>

            <button
              className="navbar-toggler collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => {
                setIsExpanded(!isExpanded);
              }}
            >
              <span className="navbar-toggler-icon">
                <i className="fas fa-bars"></i>
              </span>
            </button>

            <div
              className={`navbar-collapse collapse ${isExpanded ? 'show' : 'hide'}`}
              id="navbarCollapse"
            >
              <ul className="navbar-nav ml-auto">
                <li>
                  <NavLink onClick={onLinkClick} to={getSectionLink('home')}>
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink onClick={onLinkClick} to={getSectionLink('how-it-works')}>
                    How it Works
                  </NavLink>
                </li>
                <li>
                  <NavLink onClick={onLinkClick} to={getSectionLink('pricing')}>
                    Pricing
                  </NavLink>
                </li>
                <li>
                  <NavLink onClick={onLinkClick} to={getSectionLink('features')}>
                    Features
                  </NavLink>
                </li>
                <li>
                  <NavLink onClick={onLinkClick} to={getSectionLink('contact')}>
                    Contact
                  </NavLink>
                </li>

                <li>
                  <div className="separator" />
                </li>

                <li>
                  <Link activeClassName="current" to={`${prefix}/blog`}>
                    Blog
                  </Link>
                </li>
                <li>
                  <Link activeClassName="current" to={`${prefix}/tutorials`}>
                    Tutorials
                  </Link>
                </li>

                <li className="discover-link">
                  <a
                    href="https://app.timesheet.global/login"
                    className="external discover-btn"
                  >
                    Sign In
                  </a>
                </li>
                <li className="discover-link">
                  <a
                    href="https://app.timesheet.global/signup"
                    className="external discover-btn sign-up-btn"
                  >
                    Sign Up
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
